import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

console.log('[ACFE] main.ts: bootstrap starting', {
  production: environment.production,
  apiUrl: environment.apiUrl,
  origin: typeof location !== 'undefined' ? location.origin : 'unknown',
  href: typeof location !== 'undefined' ? location.href : 'unknown',
});

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .then(() => console.log('[ACFE] main.ts: bootstrap complete'))
  .catch((err) => console.error('[ACFE] main.ts: bootstrap failed', err));
